import(/* webpackMode: "eager", webpackExports: ["AuroraBackground","LetterReveal","ScrambleText","ScrollReveal","Tilt","GlowCard"] */ "/app/askfinz.com/components/marketing/animations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlurFade"] */ "/app/askfinz.com/components/marketing/blur-fade.tsx");
;
import(/* webpackMode: "eager" */ "/app/askfinz.com/components/marketing/number-ticker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformPillarGrid"] */ "/app/askfinz.com/components/marketing/platform-pillar-grid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformRunDiagram"] */ "/app/askfinz.com/components/marketing/platform-run-diagram.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformWorkspaceGrid"] */ "/app/askfinz.com/components/marketing/platform-workspace-grid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformWorkspaceSwitcher"] */ "/app/askfinz.com/components/marketing/platform-workspace-switcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Spotlight"] */ "/app/askfinz.com/components/marketing/spotlight.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
